/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CheckLimitResponse } from '../../entities/v1/CheckLimitResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1CheckLimitResponseSchema = z.object({
  limit_count: z.number().int().describe('лимит количества заявок за период'),
  limit_period: z.number().int().describe('период в часах'),
  success: z.boolean().describe('true - лимит не превышен, false - лимит превышен'),
}) as unknown as ToZod<V1CheckLimitResponse>